import React from 'react';

import '../style.css';
import CONF from '../Conf';
import RightChevronIcon from '../Icons/RightChevron';

export default function ContactSupportButton({ fillColor, redirectLinkOnClick, redirectType }) {
  switch (redirectType) {
    default:
    case 'presentWebView':
      return (
        <button
          className='ContactSupport'
          onClick={() => {
            if (window.android && window.android.presentWebView) {
              window.android.presentWebView(redirectLinkOnClick);
            } else if (
              window.webkit &&
              window.webkit.messageHandlers &&
              window.webkit.messageHandlers.presentWebView &&
              window.webkit.messageHandlers.presentWebView.postMessage
            ) {
              window.webkit.messageHandlers.presentWebView.postMessage(redirectLinkOnClick);
            } else {
              window.location.href = redirectLinkOnClick;
            }
          }}>
          <span>{CONF.text['Contact Support']()}</span>
          <RightChevronIcon fill={fillColor} />
        </button>
      );
    case 'deepLink':
      return (
        <button
          className='LearnMore'
          onClick={() => {
            if (window.android && window.android.presentWebView) {
              window.android.presentWebView(redirectLinkOnClick);
            } else if (
              window.webkit &&
              window.webkit.messageHandlers &&
              window.webkit.messageHandlers.presentBrowser &&
              window.webkit.messageHandlers.presentBrowser.postMessage
            ) {
              window.webkit.messageHandlers.presentBrowser.postMessage(redirectLinkOnClick);
            } else {
              window.location.href = redirectLinkOnClick;
            }
          }}>
          <span>{CONF.text['Contact Support']()}</span>
          <RightChevronIcon fill={fillColor} />
        </button>
      );
  }
}
